import { SelectSkeleton } from '../SelectSkeleton';

import { SelectProps } from './Select.decl';
import { SelectInput } from './SelectInput';

export function Select(props: SelectProps) {
  return <SelectSkeleton {...props} inputComponent={SelectInput} />;
}
